import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import {
  AlarmRuleTriggerCronConfig,
  AlarmRuleTriggerType,
} from '../../../../../../../types/dtos/alarm-rule-trigger.dto';
import { AlarmRuleTriggerFormDto } from '../../../../../../../types/dtos/alarm-rule.dto';
import { BaseRuleTrigger } from '../base-rule-trigger';
import { CronTrigger } from './cron-trigger';


export class CronRuleTrigger extends BaseRuleTrigger {
  public getDescription(): string {
    return 'common.alarm-rule.trigger.cron-job.description';
  }

  public getIcon(): string {
    return 'schedule';
  }

  public getName(): string {
    return 'common.alarm-rule.trigger.cron-job.title';
  }

  public getType(): AlarmRuleTriggerType {
    return AlarmRuleTriggerType.CRON;
  }

  public getEditorComponent(): any {
    return CronTrigger;
  }

  public configToFrom(data: AlarmRuleTriggerCronConfig): Record<string, unknown> {
    return {
      cron: data.cron,
    };
  }

  public formToConfig(form: AlarmRuleTriggerFormDto): Record<string, unknown> {
    return {
      cron: form.cron,
    };
  }

  public getFromControls(): Record<string, AbstractControl> {
    return {
      cron: new FormControl<string>('0 */6 * * *', {
        nonNullable: true,
        validators: [
          Validators.required,
          this.cronValidator(),
        ],
      }),
    };
  }


  private CRON_REGEX: RegExp = /^(\*|([0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])|\*\/([0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])) (\*|([0-9]|1[0-9]|2[0-3])|\*\/([0-9]|1[0-9]|2[0-3])) (\*|([1-9]|1[0-9]|2[0-9]|3[0-1])|\*\/([1-9]|1[0-9]|2[0-9]|3[0-1])) (\*|([1-9]|1[0-2])|\*\/([1-9]|1[0-2])) (\*|([0-6])|\*\/([0-6]))$/;

  private cronValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null; // required-Prüfung übernimmt Validators.required
      }

      const isValid: boolean = this.CRON_REGEX.test(value.trim());
      return isValid ? null : { invalidCron: true };
    };
  }
}